import { NgModule } from '@angular/core';

import { PolicyRoutingModule } from './policy-routing.module';
import { PolicyComponent } from './policy.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { CustomizationService } from 'src/services/customization.service';
import { PageLayoutModule } from 'src/app/belender/page-layout/page-layout.module';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/shared/modules/materia.module';


@NgModule({
  declarations: [PolicyComponent],
  imports: [
    CommonModule,
    PolicyRoutingModule,
    MatProgressSpinnerModule,
    PageLayoutModule,
    MaterialModule
  ],
  providers: [
    CustomizationService
  ],
})
export class PolicyModule { }
